import { Component } from 'react';
import type { Button as ButtonType } from '../types/ChatWindow';
import type { MessageScheme } from '../types/configs';

class QuickReply extends Component<
  {
    button: ButtonType;
    onClick: (...args: any[]) => void;
    scheme: MessageScheme;
  },
  { hover: boolean }
> {
  constructor(props: {
    button: ButtonType;
    onClick: (...args: any[]) => void;
    scheme: MessageScheme;
  }) {
    super(props);
    this.state = {
      hover: false,
    };
  }

  handleClick = () => {
    const { onClick, button } = this.props;
    onClick(button);
  };

  toggleHover = () => {
    const { hover } = this.state;
    this.setState({
      hover: !hover,
    });
  };

  render() {
    const {
      button: { title },
      scheme: {
        buttonEdgeColor,
        buttonTextColor,
        buttonHoverColor,
        buttonBackgroundColor,
      },
    } = this.props;

    const { hover } = this.state;
    return (
      <button
        type='button'
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
        className='button-outline'
        style={{
          color: hover ? buttonHoverColor : buttonTextColor,
          borderColor: hover ? buttonHoverColor : buttonEdgeColor,
          backgroundColor: buttonBackgroundColor,
        }}
        onClick={() => {
          this.handleClick();
        }}>
        {title.toString()}
      </button>
    );
  }
}

export default QuickReply;
